import React from 'react';
import { useT } from 'src/i18n';
import { Ellipse } from 'src/ui/svg/SVGs';

import './Preview.scss';

export const Preview = () => {
  const t = useT();

  return (
    <>
      <h1 className="heading heading_preview">
        {t.preview.name}
      </h1>

      <div className="preview-working">
        <div className="paragraph paragraph_preview">
          {t.preview.tagline}
          <br />
          {t.preview.subline}
        </div>
        <Ellipse />
      </div>

      <div className="preview-cta">
        <a
          className="button preview-cta__button"
          href={t.contacts.telegramUrl}
          target="_blank"
          rel="noreferrer"
        >
          {t.preview.ctaTelegram}
        </a>
        <a
          className="button preview-cta__button preview-cta__button_purple"
          href={`mailto:${t.contacts.email}`}
        >
          {t.preview.ctaEmail}
        </a>
      </div>

      <div className="preview-stats">
        {t.preview.stats.map((stat) => (
          <div className="preview-stats__item" key={stat.label}>
            <span className="preview-stats__value">{stat.value}</span>
            <span className="preview-stats__label">{stat.label}</span>
          </div>
        ))}
      </div>
    </>
  );
};
